import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/mortgage',
  name: 'MortgageFinancialModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'MortgageFinancialMainRoute',
      component: () => import('./views/MortgageView.vue'),
      meta: {
        title: 'mortgageEstate.mortgageContract',
      },
    },
    {
      path: 'create',
      name: 'MortgageFinancialCreateRoute',
      component: () => import('./views/MortgageUpsertView.vue'),
      meta: {
        title: 'mortgageEstate.createViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:mortgageFinancialId',
      name: 'MortgageFinancialEditRoute',
      component: () => import('./views/MortgageUpsertView.vue'),
      meta: {
        title: 'mortgageEstate.editViewTitle',
        pageHasBack: true,
      },
    },
    {
      path: 'renew/:mortgageFinancialId',
      name: 'MortgageFinancialRenewRoute',
      component: () => import('./views/MortgageUpsertView.vue'),
      meta: {
        title: 'renewContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:mortgageFinancialId',
      name: 'ViewMortgageFinancialRoute',
      component: () => import('./views/SingleMortgageView.vue'),
      meta: {
        title: 'mortgageEstate.singleViewTitle',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
